import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.templeisraelofbrevard.org";

export default function SEOHead({ title, description, path = "/", image, jsonLd }) {
  const fullTitle = title
    ? `${title} | Temple Israel of Brevard`
    : "Temple Israel of Brevard | Reform Synagogue, Melbourne FL";
  const canonical = `${SITE_URL}${path}`;
  const desc =
    description ||
    "A welcoming Reform Jewish congregation in Brevard County, Florida - since 1965.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
